import { FormattedMessage } from "react-intl";

import { Divider } from "@ps-design-system/components/Divider";
import { Text } from "@ps-design-system/components/Text";
import { HowDidYouHearOptions } from "./HowDidYouHearOptions";
import ProfileAvatar from "./ProfileAvatar";
import { ProfileName } from "./ProfileName";
import { ProfilePhone } from "./ProfilePhone";
import { PhotoTipItem } from "./PhotoTipItem";

export const ProfilePage = () => {
  return (
    <div className="profile-page-container col-sm-11 page">
      <div className="col-md-9 profile-inputs">
        <Text typeface="headline-4">
          <FormattedMessage
            id="hosting.profile_page.name_heading"
            defaultMessage="Who will guests be contacting?"
          />
        </Text>
        <Text typeface="body-2" className="tw-mb-24">
          <FormattedMessage
            id="hosting.profile_page.name_text"
            defaultMessage="Please do not use a business name, so it’s more personal for your guests."
          />
        </Text>
        <div className="tw-flex tw-flex-col">
          <ProfileName />
          <Divider spacing={16} />
          <ProfilePhone />
        </div>

        <div className="tw-flex tw-flex-col">
          <hr className="tw-mb-36" />
          <Text typeface="headline-4">
            <FormattedMessage
              id="hosting.profile_page.photo_prompt_heading"
              defaultMessage="Add a profile photo with your face"
            />
          </Text>
          <Text typeface="body-2" className="tw-mb-24">
            <FormattedMessage
              id="hosting.profile_page.photo_prompt_text"
              defaultMessage="Choose a friendly, accurate photo to help instill a sense of trust and verification in your listing"
            />
          </Text>
          <div className="tw-flex"></div>
          <ProfileAvatar />
          <div className="col-xs-12 tw-mb-16 tw-pl-0">
            <span>
              <img
                alt=""
                src="/web-hosting/assets/images/lightbulb.png"
                className="tw-w-[23px] tw-mr-16"
              />
            </span>
            <span>
              <FormattedMessage
                id="hosting.profile_page.photo_tips"
                defaultMessage="Photo Tips"
              />
            </span>
          </div>
          <PhotoTipItem
            description={
              <FormattedMessage
                id="hosting.profile_page.no_photos_description"
                defaultMessage="No photos of the space"
              />
            }
            src="/web-hosting/assets/images/photo-tips-1.png"
          />
          <PhotoTipItem
            description={
              <FormattedMessage
                id="hosting.profile_page.no_logos_description"
                defaultMessage="No business logos"
              />
            }
            src="/web-hosting/assets/images/photo-tips-2.png"
          />
          <PhotoTipItem
            description={
              <FormattedMessage
                id="hosting.profile_page.no_group_photos"
                defaultMessage="No group photos"
              />
            }
            src="/web-hosting/assets/images/photo-tips-3.png"
          />
        </div>
        <HowDidYouHearOptions />
      </div>
    </div>
  );
};
